module.exports = "<div><span class=\"notificationTextContent\" data-notify-text/></div>"